import { render, staticRenderFns } from "./InvoiceReturn.vue?vue&type=template&id=52c3100a&scoped=true"
import script from "./InvoiceReturn.vue?vue&type=script&lang=js"
export * from "./InvoiceReturn.vue?vue&type=script&lang=js"
import style0 from "./InvoiceReturn.vue?vue&type=style&index=0&id=52c3100a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c3100a",
  null
  
)

export default component.exports